import { render, staticRenderFns } from "./jobs.page.vue?vue&type=template&id=c8820618&scoped=true&"
import script from "./jobs.page.vue?vue&type=script&lang=js&"
export * from "./jobs.page.vue?vue&type=script&lang=js&"
import style0 from "./jobs.page.vue?vue&type=style&index=0&id=c8820618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8820618",
  null
  
)

export default component.exports